// LandingPage.js
import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import WhyVihana from '../components/why-vihana/WhyVihana';

const WhyVihanaPage = () => {
  return (
    <div>
      <Header />
      <WhyVihana />
      <Footer />
    </div>
  );
};

export default WhyVihanaPage;
